import { render, staticRenderFns } from "./dosageEditor.vue?vue&type=template&id=5a613e4e&scoped=true&"
import script from "./dosageEditor.vue?vue&type=script&lang=js&"
export * from "./dosageEditor.vue?vue&type=script&lang=js&"
import style0 from "./dosageEditor.vue?vue&type=style&index=0&id=5a613e4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a613e4e",
  null
  
)

export default component.exports